import { ChartCanvas } from "@/components/analytics/ChartCanvas";
import type { EmployeeKpiRow } from "@/lib/reporting.api";
import { useEmployeeValueChartConfig } from "../hooks/useEmployeeValueChartConfig";

export function EmployeeValueChartSection({ rows }: { rows: EmployeeKpiRow[] }) {
  const chartConfig = useEmployeeValueChartConfig(rows);

  return (
    <div className="mb-6 rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">
        Comparaison - valeur générée par employé
      </p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">
        Factures créées + commissions enregistrées, sur la période sélectionnée.
      </p>
      {rows.length === 0 ? (
        <p className="py-12 text-center text-[11.5px] text-muted-foreground">
          Aucune donnée sur cette période.
        </p>
      ) : (
        <ChartCanvas
          label="Comparaison valeur par employé"
          height={Math.max(180, rows.length * 34)}
          config={chartConfig}
        />
      )}
    </div>
  );
}
